import { render, staticRenderFns } from "./PromptDialogComponent.vue?vue&type=template&id=2873641a&scoped=true"
import script from "./PromptDialogComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./PromptDialogComponent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PromptDialogComponent.vue?vue&type=style&index=0&id=2873641a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2873641a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2873641a')) {
      api.createRecord('2873641a', component.options)
    } else {
      api.reload('2873641a', component.options)
    }
    module.hot.accept("./PromptDialogComponent.vue?vue&type=template&id=2873641a&scoped=true", function () {
      api.rerender('2873641a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dialog/PromptDialogComponent.vue"
export default component.exports